<template>
  <v-sheet class="px-2 py-4 mb-4" width="100%" outlined rounded="lg">
    <div class="font-weight-bold text-body-1 py-2">
      <span>등록된 프로모션</span>
      <v-btn class="ml-3" color="primary" depressed outlined small @click="$emit('addPromotion')">프로모션추가</v-btn>
      <v-divider class="mt-3" />
    </div>
    <v-chip class="ma-1" v-for="(promotion, index) in promotions" :key="promotion.code" small close @click:close="removePromotion(index)">{{ promotion.name }}</v-chip>
    <div class="grey--text text-body-2" v-show="!promotions || !promotions.length">선택된 프로모션이 없습니다.</div>

    <v-divider class="mt-3" />
    <v-sheet class="text-caption">
      <div v-for="promotion in promotions" :key="'url-' + promotion.code">
        {{ promotion.name }} : {{ getLinkUrl(promotion) }}
        <v-btn x-small depressed icon>
          <v-icon icon size="12" @click="copyClipboard(promotion)"> mdi-content-copy </v-icon>
        </v-btn>
      </div>
    </v-sheet>
  </v-sheet>
</template>
<script>
export default {
  props: {
    promotions: {
      type: Array,
      require: true,
    },
  },
  methods: {
    removePromotion(index) {
      this.promotions.splice(index, 1)
    },
    getLinkUrl(promotion) {
      return `/reservation/package?productId=${promotion.code}&early=true`
    },
    async copyClipboard(promotion) {
      let url = this.getLinkUrl(promotion)
      await navigator.clipboard.writeText(url)
      this.$toast.success("클립보드에 복사하였습니다.")
    },
  },
}
</script>
<style></style>
